import { GridColDef } from '@mui/x-data-grid-premium';
import styles from '../../../assets/styles/components/Tables/Tables.module.scss';
import { Box, Tooltip, Typography } from '@mui/material';
import { humanizeString } from '../../../utils/stringModifier';
import { CampaignAd } from '../../../types';
import { HtmlTooltip } from '../../Tooltip';
import { Fragment } from 'react';

export const adTemplatesColumns = (isMobile: boolean) => {
  const columns: GridColDef[] = [
    {
      flex: 1,
      headerClassName: styles.header,
      field: 'name',
      headerName: 'Name',
      sortingOrder: ['desc', 'asc'],
      renderCell: (params: any) => {
        const { name, openPreview, template } = params.row;

        return (
          <Tooltip
            title={<Typography variant="body2">{name}</Typography>}
            disableInteractive
          >
            <div className={styles.name} onClick={() => openPreview(template)}>
              {name}
            </div>
          </Tooltip>
        );
      },
    },
    {
      ...(isMobile ? { width: 250 } : { flex: 1 }),
      field: 'description',
      headerClassName: styles.header,
      headerName: 'Description',
      sortingOrder: ['desc', 'asc'],
      renderCell: (params: any) => {
        const { description, openPreview, template } = params.row;

        return (
          <Tooltip
            title={<Typography variant="body2">{description}</Typography>}
            disableInteractive
          >
            <div className={styles.name} onClick={() => openPreview(template)}>
              {description}
            </div>
          </Tooltip>
        );
      },
    },
    {
      width: 150,
      field: 'media',
      headerClassName: styles.header,
      headerName: 'Media',
      sortingOrder: ['desc', 'asc'],
      renderCell: (params: any) => {
        const { media, openPreview, template } = params.row;

        return (
          <Tooltip
            title={
              <Typography variant="body2">{humanizeString(media)}</Typography>
            }
            disableInteractive
          >
            <div className={styles.name} onClick={() => openPreview(template)}>
              {humanizeString(media)}
            </div>
          </Tooltip>
        );
      },
    },
    {
      width: 100,
      field: 'usages',
      headerClassName: styles.header,
      headerName: 'Usage',
      sortingOrder: ['desc', 'asc'],
      valueGetter: (_, row) => row.usageCount,
      renderCell: (params: any) => {
        const { usageCount, template, openPreview, adsUsage } = params.row;

        return usageCount > 0 ? (
          <HtmlTooltip
            disableInteractive
            title={
              <Fragment>
                <>
                  <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                    Ads Usages
                  </Typography>

                  {adsUsage?.map((usage: any, index: number) => {
                    return (
                      <Box
                        key={index + 1}
                      >{`• ${usage.name} (${usage.id})`}</Box>
                    );
                  })}
                </>
              </Fragment>
            }
          >
            <div className={styles.name}>{usageCount}</div>
          </HtmlTooltip>
        ) : (
          <div className={styles.name} onClick={() => openPreview(template)}>
            {usageCount}
          </div>
        );
      },
    },
  ];

  return columns;
};
